import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/port-aransas")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Boat Covers, T-Tops & Marine Canvas in Port Aransas, TX | Texas Made Shade",
      description: "Custom marine canvas, T-tops, biminis, boat covers and awnings for Port Aransas & Mustang Island. Built in Seguin, installed on the Texas Coast.",
      keywords: "pergola covers Port Aransas, pergola covers Texas, custom pergola covers Port Aransas, aluminum pergola covers Port Aransas",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Port Aransas, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Port Aransas and Nueces County.",
    }),
    scripts: cityHeadScripts("Port Aransas", "Nueces County"),
  }),
  component: () => <CityHomePage city="Port Aransas" region="Nueces County" />,
});
